export default function doesVendorHaveLowestDeliveryDate(
  vendorId: number,
  vendorOptions: VendorOptionState[]
): boolean {
  const deliverDatesToVendorIdMap: DeliverDatesToVendorIdMapEntry[] = [];
  vendorOptions.forEach((vo) => {
    if (vo.arrivalBusinessDays) {
      const existingEntryIndex = deliverDatesToVendorIdMap.findIndex(
        (dde) => dde.daysUntilDelivered === vo.arrivalBusinessDays
      );
      if (existingEntryIndex === -1) {
        deliverDatesToVendorIdMap.push({
          daysUntilDelivered: vo.arrivalBusinessDays,
          vendorIds: [vo.vendorId],
        });
      } else {
        deliverDatesToVendorIdMap[existingEntryIndex].vendorIds.push(vo.vendorId);
      }
    }
  });
  if (deliverDatesToVendorIdMap.length === 0) {
    return false;
  }
  deliverDatesToVendorIdMap.sort((a, b) => a.daysUntilDelivered - b.daysUntilDelivered);
  if (deliverDatesToVendorIdMap[0].vendorIds.some((vIds) => vIds === vendorId)) {
    return true;
  }
  return false;
}

type DeliverDatesToVendorIdMapEntry = {
  daysUntilDelivered: number;
  vendorIds: number[];
};
